module.exports = __webpack_public_path__ + "static/design-2-1dac6cc04f2b1e290010daacbfe7f2d0.png";